/**
 * Clasifica fallos de API como TRANSITORIOS (red caída, 5xx, timeout).
 *
 * El router guarda usa esto para NO expulsar una sesión válida a /login (ni
 * destruirla con logout) cuando el fallo es un parpadeo de red: las vistas
 * ya renderizan sus propios estados de error/reintento, y la siguiente
 * navegación reintenta la carga del contexto de tenant.
 *
 * Un fallo es transitorio cuando no hay respuesta HTTP (red/DNS/CORS) o el
 * status es 5xx (incl. 502/503/504 de un rollout de deploy). Todo lo demás
 * (401/403/404/400…) es definitivo y debe tratar como antes.
 */
export function isTransientApiError (err: unknown): boolean {
  const anyErr = err as { response?: { status?: number }; code?: string; message?: string }
  // Sin `response` axios: fallo de red, timeout, CORS o el interceptor abortó.
  if (!anyErr?.response) {
    // Un `Error` plano (p.ej. `throw new Error(response.data.message)`) NO es
    // transitorio: la API respondió y el fallo es de negocio.
    return Boolean(anyErr?.code || anyErr?.message === 'Network Error')
  }
  const status = anyErr.response.status ?? 0
  return status >= 500
}
